import React from "react";
import styles from "./styles.module.scss";
import { Col, Row } from "antd";
import { LogItemInfo } from "../../../../../../../../service/exam";
import AsidePhotoList from "../../../../../camCaptureRecord/components/AsidePhotoList";
import AsideDownload from "../../../../../download/components/AsideDownload";
import AsideMultiple from "../../../../../multipleScreen/components/AsideMultiple";
import AsideShift from "../../../../../shiftBrowser/components/AsideShift";

interface Props {
    data: LogItemInfo | null;
}
export default function AllExamInfo({ data }: Props) {
    return (
        <div className={styles.examInfo}>
            <Row className={styles.row}>
                <Col span={6} className={styles.label}>
                    登录时间
                </Col>

                <Col span={18} className={styles.text2}>
                    {data?.loginTime?.map(item => (
                        <p key="item">{item}</p>
                    ))}
                </Col>
            </Row>

            <Row className={styles.row}>
                <Col span={6} className={styles.label}>
                    IP
                </Col>

                <Col span={18} className={styles.text2}>
                    {data?.ip?.map(item => (
                        <p key="item">{item}</p>
                    ))}
                </Col>
            </Row>

            <Row className={styles.row}>
                <Col span={6} className={styles.label}>
                    浏览器
                </Col>

                <Col span={18} className={styles.text2}>
                    {data?.browser?.map(item => (
                        <p key="item">{item}</p>
                    ))}
                </Col>
            </Row>

            <Row className={styles.row}>
                <Col span={6} className={styles.label}>
                    操作系统
                </Col>

                <Col span={18} className={styles.text2}>
                    {data?.system?.map(item => (
                        <p key="item">{item}</p>
                    ))}
                </Col>
            </Row>

            <Row className={styles.row}>
                <Col span={6} className={styles.label}>
                    参考时间
                </Col>

                <Col span={18} className={styles.text2}>
                    <p>{data?.startExamTime || "--"}</p>
                </Col>
            </Row>

            <AsidePhotoList />
            <AsideDownload />
            <AsideMultiple />
            <AsideShift />
        </div>
    );
}
